import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Create Test Reward Mint", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "my-2" }, " 🎉 New mint created and 1,000,000 tokens deposited into your wallet! ", -1)
const _hoisted_5 = { class: "mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "nes-btn is-primary",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createTestReward && _ctx.createTestReward(...args)))
    }, " Create Test Mint "),
    (_ctx.mint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, "Mint: " + _toDisplayString(_ctx.mint), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}